const initialized = new WeakSet();
const SWIPE_THRESHOLD = 30;

function initGallerySwipe(mediaWrap) {
  if (initialized.has(mediaWrap)) return;
  initialized.add(mediaWrap);

  const hoverImage = mediaWrap.querySelector('.product-card-gallery__image-hover');
  const pagination = mediaWrap.querySelector('.product-card-gallery__pagination');
  const dots = pagination ? Array.from(pagination.querySelectorAll('.product-card-gallery__dot')) : [];

  if (!hoverImage || dots.length < 2) return;

  let startX = 0;
  let startY = 0;
  let tracking = false;
  let activeIndex = 0;

  function setActive(index) {
    activeIndex = index;
    hoverImage.classList.toggle('is-active', activeIndex === 1);
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === activeIndex));
  }

  mediaWrap.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
      tracking = true;
    },
    { passive: true }
  );

  mediaWrap.addEventListener(
    'touchend',
    (event) => {
      if (!tracking) return;
      tracking = false;

      const touch = event.changedTouches[0];
      if (!touch) return;

      const deltaX = touch.clientX - startX;
      const deltaY = touch.clientY - startY;
      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

      setActive((activeIndex + 1) % dots.length);
    },
    { passive: true }
  );
}

function initAll(root) {
  root.querySelectorAll('[data-gallery-swipe]').forEach(initGallerySwipe);
}

initAll(document);

new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches('[data-gallery-swipe]')) initGallerySwipe(node);
      initAll(node);
    }
  }
}).observe(document.body, { childList: true, subtree: true });
